import { useCommonConfiguration } from './useCommonConfiguration';

const DEFAULT_VALUE = false;

export const useIsUnifiedSidebarEnabled = (): boolean => {
  const commonConfiguration = useCommonConfiguration();
  return commonConfiguration?.unifiedSidebar ?? DEFAULT_VALUE;
};
